import { render } from "./TransactionBulkPage.vue?vue&type=template&id=37aa40e8&scoped=true"
import script from "./TransactionBulkPage.vue?vue&type=script&lang=js"
export * from "./TransactionBulkPage.vue?vue&type=script&lang=js"

import "./TransactionBulkPage.vue?vue&type=style&index=0&id=37aa40e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37aa40e8"]])

export default __exports__